export enum CustomPreference {
    PFA_RESTRICTED_STATES = 'restrictedStates',
    DAYS_TO_READY_FOR_PICKUP = 'daysToReadyForPickup',
    ADDRESS_SUGGEST_DEBOUNCE = 'pwaAddressSuggestionsDebounceTime',
    GOOGLE_TAG_MANAGER_ID = 'googleTagManagerID',
    NUMBER_ALLOWED_GIFT_CARDS = 'numberOfAllowedGiftCards',
    MAXIMUM_SAVED_CC = 'maximumSavedCC',
    PWA_ENABLE_CHECKOUT = 'pwaEnableCheckout',
    PWA_ENABLE_PDP = 'usePwaPdp',
    RECAPTCHA_SITEKEY = 'recaptcha_SiteKey',
    RECAPTCHA_LOGIN_ENABLED = 'recaptcha_Enabled',
    RECAPTCHA_CHECKOUT_LOGIN_ENABLED = 'recaptchaCheckoutLoginEnabled',
    RECAPTCHA_CREATE_ACCOUNT_ENABLED = 'recaptchaCreateAccountEnabled',
    RECAPTCHA_CHECKOUT_ENABLED = 'recaptcha_Checkout_Enabled',
    RECAPTCHA_CHECKOUT_GC_ENABLED = 'recaptcha_GC_Checkout_Enabled',
    RECAPTCHA_CHECKOUT_GC_BALANCE_CHECK_ENABLED = 'recaptcha_GC_BalChk_Enabled',
    RADAR_ENABLED = 'radarEnabled',
    RADAR_PUBLISHABLE = 'radarPublishable',
    ENABLE_RIO_SEO = 'enableRioSEO',
    GO_LOCAL_CUT_OFF_TIME = 'goLocalCutOffTime',
    ENABLE_THRESHOLD_SHIPPING = 'EnableThresoldShipping',
    THRESHOLD_SHIPPING_AMOUNT = 'Thresold_ShippingAmount',
    THRESHOLD_ONLY_X_LEFT_BADGE = 'onlyXLeftBadgeThreshold',
    THRESHOLD_LIMITED_QUANTITY_BADGE = 'limitedQuantityBadgeThreshold',
    LABEL_LIMITED_QUANTITY_BADGE = 'limitedQuantityBadgeLabel',
    BRAND_SPECIALIST_VIDEO_ENABLED = 'photoGridBrandSpecialistEnabled',
    EXTEND_ENABLED = 'extendGlobalSwitch',
    EXTEND_PDP_ENABLED = 'extendPDPSwitch',
    EXTEND_PDP_UP_SELL_ENABLED = 'extendPDPUpsellSwitch',
    EXTEND_CART_UP_SELL_ENABLED = 'extendCartUpsellSwitch',
    EXTEND_STORE_ID = 'extendStoreID',
    EXTEND_PRODUCTION_MODE = 'isExtendProductionMode',
    EXTEND_SDK = 'extendSDK',
    ENABLE_PDP_FREE_SHIPPING_LABEL = 'enablePDPFreeShippingLabel',
    APPLE_PAY_ENABLED_ON_NEW_PDP = 'applePayEnabledOnNewPDP',
    APPLE_PAY_ENABLED_ON_NEW_GDP = 'applePayEnabledOnNewGDP',
    APPLE_PAY_ENABLED_ON_CHECKOUT = 'applePayEnabledOnCheckout',
    APPLE_PAY_MIN_THRESHOLD_AMOUNT = 'applepayMinThresholdAmount',
    APPLE_PAY_MAX_THRESHOLD_AMOUNT = 'applepayMaxThresholdAmount',
    EDD_ENABLE = 'eddEnable',
    DEFAULT_EDD_MESSAGE = 'defaultEddMessage',
    EDD_DEFAULT_TO_ZIP_CODE = 'eddDefaultToZipCode',
    EDD_BLACKOUT_DAYS = 'eddBlackoutDays',
    ENABLE_STICKY_ATB_ON_PDP = 'enableStickyATBOnPDP',
    SET_MAX_PRODUCT_QUANTITY = 'setmaxproductquantity',
    E_GIFT_CARD_CUSTOM_MESSAGE = 'eGiftCardCustomMessage',
    ENABLE_RELATED_CATEGORIES_ON_PDP = 'optiversalEnableRelatedCategoriesOnPDP',
    ENABLE_RELATED_CATEGORIES_ON_PLP = 'optiversalEnableRelatedCategoriesOnPLP',
    STORES_INVENTORY_ID = 'storesInventoryId',
    SDD_ENABLED = 'goLocalEnabled',
    BOPIS_ENABLED = 'enableStorePickUp',
    PWA_ENABLE_CART = 'usePwaCart',
    CULINARY_CLASS_BLOCKED_THRESHOLD = 'ClassPurchaseBlockedXMinutesBefore',
    REWARDS_MESSAGING = 'rewardsMessaging',
    SAVINGS_DOLLAR_THRESHOLD = 'dollarSavingsThreshold',
    SAVINGS_FEATURE_ENABLED = 'savingsFeatureEnabled',
    ENABLE_INFORMATION_MESSAGE_CART_AND_CHECKOUT = 'enableInformationMessageCartAndCheckout',
    INFORMATION_MESSAGE_CART_AND_CHECKOUT_LINE_1 = 'informationMessageCartAndCheckoutLine1',
    INFORMATION_MESSAGE_CART_AND_CHECKOUT_LINE_2 = 'informationMessageCartAndCheckoutLine2',
    INFORMATION_MESSAGE_CART_AND_CHECKOUT_TOOLTIP = 'informationMessageCartAndCheckoutTooltip',
    ENABLE_SHIP_FAST_PDP = 'enableShipFastPDP',
    SHIP_FAST_PDP_TITLE = 'shipFastPDPTitle',
    SHIP_FAST_PDP_LINK_CAPTION = 'shipFastPDPLinkCaption',
    AFTERPAY_SDK_LINK = 'apModelJavaScriptLink',
    AFTERPAY_MPID = 'afterpayMpid',
    AFTERPAY_PLACEMENT_ID = 'afterpayPlacementId',
    PWA_ACCOUNT_REDIRECT = 'pwaAccountRedirect',
    PWA_ENABLE_GIFT_CARDS = 'pwaEnableGiftCards',
    ELECTRONIC_GIFT_CARD_IMAGE_URL = 'electronicGiftCardImageURL',
    PHYSICAL_GIFT_CARD_IMAGE_URL = 'physicalGiftCardImageURL',
    PHYSICAL_GIFT_CARD_DELIVERY_NOTIFICATION = 'physicalGiftCardDeliveryNotification',
    ELECTRONIC_GIFT_CARD_DELIVERY_NOTIFICATION = 'electronicGiftCardDeliveryNotification',
    GIFT_CARDS_WHAT_CAN_YOU_GET_LINKS = 'giftCardsWhatCanYouGetLinks',
    GIFT_CARDS_DISCOVER_COOKING_CLASSES = 'giftCardsDiscoverCookingClasses',
    ENABLE_CART_DELIVERY_OPTIONS = 'enableCartDeliveryOptions',
    COMPARISON_FEATURE_ENABLED = 'comparisonFeatureEnabled',
    COMPARISON_FEATURE_MODE = 'comparisonFeatureMode',
    PWA_SEARCH_MODE = 'pwaSearchMode',
    RADAR_AUTOCOMPLETE_ENABLED = 'enableRadarAutoCompleteOnCheckout',
    ENABLE_BOPIS_SDD_FILTERS_ON_PLP_SEARCH_PAGES = 'enableBopisSddFiltersOnPlpSearchPages',
    SHIPPING_PROTECTION_ENABLED = 'shippingProtectionEnabled',
    SHIPPING_PROTECTION_SITE_URL = 'shippingProtectionSiteUrl',
    SHIPPING_PROTECTION_DEFAULT_BEHAVIOR = 'shippingProtectionDefaultBehavior',
    SHIPPING_PROTECTION_AB_TEST_MODE = 'shippingProtectionABTestMode',
    ENABLE_QUICK_ADD_TO_BAG_PLP = 'enableQuickAddToBagPlp',
}
